var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"issued-app-container",attrs:{"data-testid":"issued-app-container"}},_vm._l((_vm.sections),function(section,index){return _c('app-section-card',{key:index,attrs:{"icon":section.icon,"title":section.title,"sections":section.sections}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }